import { Badge, ButtonBase, Tooltip } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ReactNode } from 'react';

const useStyles = makeStyles(theme => ({
  button: {
    width: 40,
    height: 40,
    borderRadius: 8,
    border: '1px solid #C5CCF2',
    background: '#fff',
    color: '#13233F',
    '&:hover': {
      background: '#F4F5FB',
      borderColor: '#8E9BE0',
    },
    '& svg': {
      fontSize: 22,
    },
  },
  primary: {
    background: '#13233F',
    borderColor: '#13233F',
    color: '#fff',
    '&:hover': {
      background: '#23375C',
      borderColor: '#23375C',
    },
  },
  disabled: {
    borderColor: '#E4E7F5',
    color: '#9AA1B9',
  },
  iconWrapper: {
    position: 'relative',
    display: 'inline-flex',
  },
  secondaryIcon: {
    position: 'absolute',
    right: -7,
    bottom: -5,
    display: 'inline-flex',
    '& svg': {
      fontSize: 13,
    },
  },
  badge: {
    fontSize: 10,
    height: 16,
    minWidth: 16,
    padding: '0 4px',
  },
}));

export const ToolbarIconButton = ({
  title,
  icon,
  secondaryIcon,
  count,
  onClick,
  disabled = false,
  primary = false,
  testId,
}: {
  title: string;
  icon: ReactNode;
  secondaryIcon?: ReactNode;
  count?: number;
  onClick: () => void;
  disabled?: boolean;
  primary?: boolean;
  testId: string;
}) => {
  const classes = useStyles();

  return (
    <Tooltip title={count ? `${title} (${count})` : title} arrow>
      {/* span keeps the tooltip working while the button is disabled */}
      <span>
        <ButtonBase
          className={clsx(
            classes.button,
            primary && classes.primary,
            disabled && classes.disabled
          )}
          onClick={onClick}
          disabled={disabled}
          aria-label={title}
          data-testid={testId}
        >
          <Badge
            badgeContent={count}
            color="primary"
            invisible={!count}
            classes={{ badge: classes.badge }}
          >
            <span className={classes.iconWrapper}>
              {icon}
              {secondaryIcon && (
                <span className={classes.secondaryIcon}>{secondaryIcon}</span>
              )}
            </span>
          </Badge>
        </ButtonBase>
      </span>
    </Tooltip>
  );
};
